import { api as apiProvider } from '@/core/api/';

const baseApiURL = 'api/loadProcess';

export const saveLoadProcess = async (model) =>
  apiProvider.post(`${baseApiURL}/save`, model);
export const getBatchLoadControlNextProcessPeriod = async (
  academicYearId,
  batchServiceId
) => {
  return await apiProvider.get(
    `${baseApiURL}/getBatchLoadControlNextProcessPeriod/`,
    {
      params: {
        academicYearId: academicYearId,
        batchServiceId: batchServiceId,
      },
    }
  );
};
